import { lang } from '@sc/data-access-models';

// Association between a language ISO code and its displayed name
export interface LanguageDisplay {
  displayed: string;
  code: lang;
}
